import { OptionType } from '../../data/options'
import { GenericQuestion, TempOptionType } from '../../data/questions'
import TextQuestion from './TextQuestion'

export type TextQuestionType = GenericQuestion & {
  min_selections: number
  max_selections: number
  type: 'text'
}

export default TextQuestion
